import styled from 'styled-components';

export const ProgressRoot = styled.div`
    display: grid;
    background-color: transparent;
    grid-column: 1;
    grid-row: 12 / 15;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(7, 1fr);    
    padding: 0px 5px;
    margin: 0;
`

export const ProgressContainer = styled.div`
    display: grid;
    width: 100%;
    text-align: center;
    background-color: darkblue;
    padding: 10px 10px;
    box-sizing: border-box;
    grid-column: 1;
    grid-row: 1 / 6;
    grid-template-columns: repeat(14, 1fr);
    grid-template-rows: repeat(5, 1fr);
`;

export const Title = styled.div`
    display: flex;
    text-align: left;
    font-size: 2rem;
    font-family: "BebasNeue";
    color: white;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    grid-column: 1 / 15;
    grid-row: 1 / 3;

    @media (max-width: 3300px) {
        font-size: 1.6rem;
    }

    @media (max-width: 1800px) {
        font-size: 1.2rem;
    }

    @media (max-width: 1420px) {
        font-size: 0.8rem;
    }

    @media (max-width: 1110px) {
        font-size: 0.5rem;
    }
`;

export const ProgressBarWrapper = styled.div`
    position: relative;
    display: grid;
    box-sizing: border-box;
    overflow: hidden;
    background-color: transparent;
    grid-column: 1 / 15;
    grid-row: 3 / 6;
    grid-template-columns: repeat(14, 1fr);
    grid-template-rows: repeat(2, 1fr);

    @media (max-width: ${({ theme }) => theme.mintProgressBarWidthBreakpoint}) {
        grid-template-rows: repeat(1, 1fr);
    }

    > * {
        border: 1px solid white;
    }
`;

export const ProgressValueContainer = styled.div`
    display: grid;
    grid-column: 1 / 15;
    grid-row: 3 / 6;
    grid-template-columns: repeat(100, 1fr);
    grid-template-rows: repeat(1, 1fr);
`

export const Progress = styled.div`
    background-color: green;
    grid-row: 1;
`;

export const Scale = styled.div`
    // border: 2px solid lime;
    display: grid;    
    padding: 0px 10px;
    font-family: Arial, sans-serif;
    font-size: 14px;
    padding-top: 5px;
    grid-column: 1;
    grid-row: 6 / 8;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);    

    @media (max-width: ${({ theme }) => theme.mintProgressBarWidthBreakpoint}) {
        grid-template-rows: repeat(1, 1fr);
        font-size: 10px;
    }
`;

export const ScaleSpan = styled.div`
    display: flex;    
    grid-row: 2;
    // padding-top: 2px;
    font-size: 15px;
    margin: 0;
    line-height: 1;
    vertical-align: bottom;
    align-items: end;

    @media (max-width: 1540px) {
        font-size: 12px;
    }

    @media (max-width: 1300px) {
        font-size: 10px;
    }

    @media (max-width: 1100px) {
        font-size: 6px;
    }

    @media (max-width: 1110px) {
        // font-size: 0.5rem;
    }
`;

export const Stroke = styled.div`
    display: grid;
    border-left: 2px solid white;
    grid-row: 1;
    margin: 2px 0px;
`;